import React from 'react';
import withAppState from '../../../mobx/withAppState'
import { Steps } from '../../../lib/constants';
import ApplyVoucher from '../../../components/ApplyVoucher';

const MiPayAtTableApplyVoucherWrapper = (props) => {
  const goToRegister = () => {
    props.goToStep(Steps.REGISTER);
  }

  const goToRegisterFromSocial = (profile) => {
    props.setSocialCustomer(profile);
    props.goToStep(Steps.REGISTER);
  }

  const goToForgottenPassword = (cachedEmailAddress) => {
    props.setCachedEmailAddress(cachedEmailAddress);
    props.goToStep(Steps.FORGOTTEN_PASSWORD);
  }

  const handleConfirmVoucher = (offer) => {
    props.popStep();
  };

  const handleApplyVoucherSuccessResponse = async (response) => {
    let data;
    try {
      data = await response.json();
    } catch (err) {
      props.setErrorModalMessage(
        'We were unable to apply this voucher code.'
      );
    }

    const { success, bills, reason } = data;
    if (success === true) {
      props.setBill(bills);
      props.popStep();
    } else {
      props.setErrorModalMessage(reason ? reason : 
        'We were unable to apply this voucher code.'
      );
    }
  }


  props.setBufferedAction(() => {
    props.goToStepWithoutHistory(Steps.APPLY_VOUCHER);
  })

  return (
    <ApplyVoucher
      handleApplyVoucherSuccessResponse={handleApplyVoucherSuccessResponse}
      goToRegisterFromSocial={goToRegisterFromSocial}
      goToForgottenPassword={goToForgottenPassword}
      handleConfirmVoucher={handleConfirmVoucher}
      signUp={goToRegister}
    />
  )
}

export default withAppState(MiPayAtTableApplyVoucherWrapper,
  {
    mobXActions: ({
      goToStepWithoutHistory,
      setErrorModalMessage,
      setBill,
      popStep,
      setSocialCustomer,
      goToStep,
      setCachedEmailAddress,
      setBufferedAction,
    }) => ({
      goToStepWithoutHistory,
      setErrorModalMessage,
      setBill,
      popStep,
      setSocialCustomer,
      goToStep,
      setCachedEmailAddress,
      setBufferedAction,
    })
  }
);